import { BlurTargetView, BlurView } from "expo-blur";
import { createContext, PropsWithChildren, useContext, useRef } from "react";
import { ImageBackground, StatusBar, StyleSheet, View } from "react-native";

import { Box, Center } from "@whoosh/design-system/src/components/primitive";
import { images } from "@whoosh/design-system/src/theme/images";

import { useSuppressLocaleTransitionAnimation } from "../../../LanguagePreference";

const AuthenticationLayoutContext = createContext(false);

export const useAuthenticationLayoutLanguageSelect = () =>
  useContext(AuthenticationLayoutContext);

export const AuthenticationLayoutLanguageSelectProvider = ({
  children,
}: PropsWithChildren) => {
  useSuppressLocaleTransitionAnimation();

  return (
    <AuthenticationLayoutContext.Provider value={true}>
      {children}
    </AuthenticationLayoutContext.Provider>
  );
};

export const AuthenticationLayout = ({ children }: PropsWithChildren) => {
  const blurTargetRef = useRef<View | null>(null);

  return (
    <AuthenticationLayoutLanguageSelectProvider>
      <StatusBar
        backgroundColor="transparent"
        translucent
        barStyle="light-content"
      />
      <View style={{ flex: 1 }}>
        <BlurTargetView ref={blurTargetRef} style={{ flex: 1 }}>
          <ImageBackground
            source={images.desktopLandingBackground}
            resizeMode="cover"
            style={{ flex: 1, height: "100%", width: "100%" }}
            testID="authentication-background"
          />
        </BlurTargetView>
        <BlurView
          blurMethod="dimezisBlurViewSdk31Plus"
          blurTarget={blurTargetRef}
          intensity={50}
          style={StyleSheet.absoluteFill}
        >
          <Box
            position="absolute"
            top={0}
            bottom={0}
            right={0}
            left={0}
            backgroundColor="surface-overlay"
            opacity={0.7}
          />

          <Center flex={1}>{children}</Center>
        </BlurView>
      </View>
    </AuthenticationLayoutLanguageSelectProvider>
  );
};
